import React from 'react';

import styled from 'styled-components';

import { Typography12 } from 'uiToolkit/Typography';

const PreviewAlert = ({ message = 'This is a preview.' }) => (
  <Wrapper>
    <Typography12 color="primary">{message}</Typography12>
  </Wrapper>
);

export default PreviewAlert;

const Wrapper = styled.div`
  background: ${(props) => props.theme.palette.background.lightBlue};
  padding: 1rem 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
